import styled from "styled-components"
import { Hero } from "./Hero"
import EngagementSection from "./EngagementSection"
import ServicesSection from "./ServicesSection"
import CoverageSection from "./CoverageSection"
import Header from "../Common/Header"
import Footer from "../Common/Footer"
import { CTASecondary } from "./CTASecondary"
import GoogleReviews from "@features/GoogleReviews"
import Popup from "@components/layout/Popup"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import ProcessSection, { ProofStrip } from "./ProcessSection"

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f8fb;
`

const Main = styled.main`
  width: 100%;
`

export const Homepage = () => {
  const [isPopupVisible, setPopupVisible] = useState(false)
  const popupTriggered = useRef(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      const cookieChoiceMade = document.cookie.split("; ").some((row) => row.startsWith("cookie_consent="))

      if (cookieChoiceMade && !popupTriggered.current && window.scrollY > window.innerHeight * 1.5) {
        popupTriggered.current = true
        setPopupVisible(true)
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <Layout>
      <Header />
      <Main id="contenu-principal">
        <Hero />
        <ProofStrip />
        <EngagementSection />
        <ServicesSection />
        <ProcessSection />
        <CoverageSection />
        <GoogleReviews />
        <CTASecondary />
      </Main>
      <Footer />
      {isPopupVisible && (
        <Popup
          title="Demandez une soumission"
          text="Décrivez-nous votre immeuble et les tâches que vous souhaitez déléguer. Nous vous recontacterons pour préciser le mandat."
          buttonLabel="Remplir la demande"
          onClose={() => setPopupVisible(false)}
          onClick={() => {
            setPopupVisible(false)
            navigate("/faire-une-demande")
          }}
          imageUrl="/img/interieur-maison-unite.jpg"
        />
      )}
    </Layout>
  )
}

export default Homepage
